<template>
  <button class="button-edit" type="button" @click="$emit('click')">
    <slot>Edit</slot>
  </button>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

.button-edit {
  color: darken(saturate(adjust-hue($theme-color-secondary, -2), 4.27), 4.12);
  cursor: pointer;
  font-size: 1rem;
  font-weight: $typography-weight-bold;
  letter-spacing: 0.08rem;
  line-height: 1.6;
}
</style>
